/*
 * @Author: your name
 * @Date: 2021-10-26 11:33:58
 * @LastEditTime: 2021-11-04 16:49:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /we-media/src/api/index.js
 */
import { axios } from '@zyf2e/adapt';
/**
 *
 * 内容相关接口 文档
 * http://mock.qa.91jkys.com/api/project/test/174/
 * http://mock.qa.91jkys.com/project/174?moduleId=990&interfaseId=7673
 */

export function onGiveLike(params) {
  return axios.post(`pgc_content/1.0/user_interact`, params);
}

export function getListByTag(params) {
  return axios.get(`pgc_content/1.0/query_label_content`, { params });
}

export function getTabList(params) {
  return axios.get(`pgc_content/1.0/tab_list`, { params });
}

export function getTabContentList(params) {
  return axios.get(`pgc_content/1.0/recommend_list`, { params });
}

export function getContentDetail(params) {
  return axios.get(`pgc_content/1.0/client_content_detail`, {
    params,
  });
}

export function getContentRelative(params) {
  return axios.get(`pgc_content/1.0/query_relative_content`, {
    params,
  });
}

export function getContentAdvBanner(params) {
  return axios.get(`composite-portal/1.0/get_content_banner`, {
    params,
  });
}

// 关注
export function followDoctor(params) {
  return axios.post('doctor/3.0/follow_doctor', params);
}

// 去掉关注
export function unFollowDoctor(params) {
  return axios.post('doctor/3.0/unfollow_doctor', params);
}

export function getDoctorInfo(params) {
  return axios.get(`composite_doctor_info/1.0/doctor_info`, {
    params,
  });
}

export function getDoctorArticleDetail(params) {
  return axios.get(`pgc_doctor/1.0/content_detail`, {
    params,
  });
}

// 记录播放数
export function recordPlay(params) {
  return axios.post('pgc_doctor/1.0/video_play_count', params);
}

// 删除
export function deletArticle(params) {
  return axios.post('pgc_doctor/1.0/content_delete', params);
}

// 撤回
export function rejectArticle(params) {
  return axios.post('pgc_doctor/1.0/content_recall', params);
}

export function getUserContentList(params) {
  return axios.get(`pgc_content/1.0/user_content_list`, {
    params,
  });
}

// 获取审核当前内容的医生列表
export function fetchGetPgcContentContentApproveDoctorList(params) {
  return axios.get(`pgc_content/1.0/content_approve_doctor_list`, { params });
}

// 审核操作
export function auditByDoctor(params) {
  return axios.post(`doctor_task/1.0/task_audit_content`, params);
}

// 用药指导一级类目查询
export function getCategoryOneList(params) {
  return axios.get(`pgc_guidelines/1.0/query_first_category_list`, { params });
}

// 二级
export function getCategorySecondList(params) {
  return axios.get(`pgc_guidelines/1.0/query_second_category_list`, { params });
}

// 获取热门类目
export function getHotSecondCategory(params) {
  return axios.get(`pgc_guidelines/1.0/query_default_category_list`, {
    params,
  });
}

// 获取二级目录相关药品
export function getCategoryDrug(params) {
  return axios.get(`pgc_guidelines/1.0/query_rely_content_list`, { params });
}
